const API_CORE_HOST = String(process.env.VUE_APP_API_HOST);
const accounts = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace('/', '');
const education = String(process.env.VUE_APP_EDUCATION_PREFIX).replace('/', '');
const ACCOUNT_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX.replace('/', '');
const ORGANIZATION_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ORGANIZATION_PREFIX.replace('/', '');
// const EDUCATION_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_EDUCATION_PREFIX.replace('/', '');
const SURVEY_HOST = process.env.VUE_APP_API_HOST + process.env.VUE_APP_SURVEY_PREFIX.replace('/', '');
const ACCOUNTS_INSTANCE = String(process.env.VUE_APP_ACCOUNTS_PREFIX).replace('/', '');
const ORGANIZATION_INSTANCE = String(process.env.VUE_APP_ORGANIZATION_PREFIX).replace('/', '');
// const EDUCATION_INSTANCE = String(process.env.VUE_APP_EDUCATION_PREFIX).replace('/', '');
const SURVEY_INSTANCE = String(process.env.VUE_APP_SURVEY_PREFIX).replace('/', '');
const CONFIRMATION_INSTANCE = String(process.env.VUE_APP_CONFIRMATION_PREFIX).replace('/', '');
const CONFIRMATION_LINK = process.env.VUE_APP_CONFIRMATION_LINK
const REGEXP_LINK = /\b((?:https?:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'\".,<>?«»“”‘’]))|(\[[^\]]+\([^\)]+\))/gmi


export {
    API_CORE_HOST,
    ACCOUNT_HOST,
    ACCOUNTS_INSTANCE,
    ORGANIZATION_HOST,
    ORGANIZATION_INSTANCE,
    // EDUCATION_HOST,
    // EDUCATION_INSTANCE,
    SURVEY_HOST,
    SURVEY_INSTANCE,
    CONFIRMATION_INSTANCE,
    CONFIRMATION_LINK,
    REGEXP_LINK
}
export default {
    accounts,
    education,
}
